module.exports = __webpack_public_path__ + "static/media/portfolio1 (48).d711283e.jpeg";